import classes from "./Navbar.module.css";

import clsx from "clsx";
import { useScroll } from "hooks/useScroll";
import { useEffect, useState } from "react";

import { PiSidebar } from "react-icons/pi";

const Navbar = ({ sidebar, setSidebar }) => {
  const isScrolled = useScroll(20);

  return (
    <div
      className={clsx(
        classes.wrapper,
        isScrolled && classes.wrapperBg,
        !sidebar && classes.noLeftSidebarWrapper
      )}
    >
      <nav className={clsx(classes.nav, "container2")}>
        <button
          className={classes.sidebarButton}
          onClick={() => setSidebar((prev) => !prev)}
        >
          <PiSidebar />
        </button>
      </nav>
    </div>
  );
};
export default Navbar;
